export const splitTitleCase = (word: string): string => {
    return word.replace('Idle', '')
        .replace(/([a-z])([A-Z])/g, (match, p1, p2) => `${p1} ${p2.toLowerCase()}`)
}